<template><!--聊天相关-->
  <div style="padding: 10px">
    <div>聊天相关</div>
    <hr>
    <!--男-->
    <el-collapse v-model="activeName" accordion v-if="sex === '1'">
      <el-collapse-item title="聊天消耗什么" name="1">
        <div class="collapse-item-div">● 聊天(包含回复漂流瓶)消耗10积分/金币，优先消耗积分。</div>
      </el-collapse-item>
      <el-collapse-item title="如何免费聊天" name="2">
        <div class="collapse-item-div">● 每日扔漂流瓶和发送瞬间可以获取一定数量的积分。</div>
      </el-collapse-item>
      <el-collapse-item title="机器脚本/导流/广告等聊天举报" name="3">
        <div class="collapse-item-div">● 平台内都为真人聊天，发现异常聊天用户可以及时举报。审核确认违规后举报用户可以获得聊天奖励</div>
      </el-collapse-item>
      <el-collapse-item title="应用内消息提醒设置" name="4">
        <div class="collapse-item-div">● 应用内提醒指在app开启的情况下，顶部的横幅提示。</div>
        <div class="collapse-item-div">● 用户可在在设置-应用内提醒中进行提示音开关、消息详情开关等设置。</div>
      </el-collapse-item>
      <el-collapse-item title="离线消息提醒设置" name="5">
        <div class="collapse-item-div">● 离线消息指app在没有启动或长期后台运行时收到的消息。</div>
        <div class="collapse-item-div">● 用户可以在设置-消息推送设置中按照提示打开，app未运行也可收到消息。</div>
        <div class="collapse-item-div">● 由于手机厂商限制，目前仅支持华为、小米、oppo和vivo手机。</div>
      </el-collapse-item>
    </el-collapse>

    <!--女-->
    <el-collapse v-model="activeName" accordion v-if="sex === '2'">
      <el-collapse-item title="聊天可以得到金币，金币可以提现" name="1">
        <div class="collapse-item-div">● 聊天或收到礼物可以得到金币，200金币起就可以提现。</div>
      </el-collapse-item>
      <el-collapse-item title="为什么聊天偶尔没有收益" name="2">
        <div class="collapse-item-div">● 男性用户完成每日任务可以获得少量积分，得到免费聊天的机会。聊天优先消耗积分，积分消耗完就可以获得收益了。</div>
      </el-collapse-item>
      <el-collapse-item title="机器脚本/导流/广告等聊天举报" name="3">
        <div class="collapse-item-div">● 平台内都为真人聊天，发现异常聊天用户可以及时举报。审核确认违规后举报用户可以获得聊天奖励。</div>
      </el-collapse-item>
      <el-collapse-item title="如何让他人找到我" name="4">
        <div class="collapse-item-div">● 扔漂流瓶、回复漂流瓶、发送瞬间可以很快获得回复。</div>
        <div class="collapse-item-div">● 认证用户将会得到优先展示机会。</div>
      </el-collapse-item>
      <el-collapse-item title="提现与到账时间" name="5">
        <div class="collapse-item-div">● 提交成功后将在工作时间内一小时内处理完成（节假日和凌晨时间段可能顺延至工作时间）</div>
      </el-collapse-item>
      <el-collapse-item title="应用内消息提醒设置" name="6">
        <div class="collapse-item-div">● 应用内提醒指在app开启的情况下，顶部的横幅提示。</div>
        <div class="collapse-item-div">● 用户可在在设置-应用内提醒中进行提示音开关、消息详情开关等设置。</div>
      </el-collapse-item>
      <el-collapse-item title="离线消息提醒设置" name="7">
        <div class="collapse-item-div">● 离线消息指app在没有启动或长期后台运行时收到的消息。</div>
        <div class="collapse-item-div">● 用户可以在设置-消息推送设置中按照提示打开，app未运行也可收到消息。</div>
        <div class="collapse-item-div">● 由于手机厂商限制，目前仅支持华为、小米、oppo和vivo手机。</div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: '1',
      sex: this.$route.query.sex
    }
  },
  methods: {

  },
  created() {
  }
}
</script>

<style>

</style>
